'use strict';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _Symbol$for;

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

import fetchWithNetworkError from '@uppy/utils/lib/fetchWithNetworkError';
import ErrorWithCause from '@uppy/utils/lib/ErrorWithCause';
import AuthError from './AuthError.js';
var packageJson = {
  "version": "3.1.3"
}; // Remove the trailing slash so we can always safely append /xyz.

function stripSlash(url) {
  return url.replace(/\/$/, '');
}

function handleJSONResponse(_x) {
  return _handleJSONResponse.apply(this, arguments);
} // todo pull out into core instead?


function _handleJSONResponse() {
  _handleJSONResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(res) {
    var jsonPromise, errMsg, errData;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!(res.status === 401)) {
              _context8.next = 2;
              break;
            }

            throw new AuthError();

          case 2:
            jsonPromise = res.json();

            if (!res.ok) {
              _context8.next = 5;
              break;
            }

            return _context8.abrupt("return", jsonPromise);

          case 5:
            errMsg = "Failed request with status: ".concat(res.status, ". ").concat(res.statusText);
            _context8.prev = 6;
            _context8.next = 9;
            return jsonPromise;

          case 9:
            errData = _context8.sent;
            errMsg = errData.message ? "".concat(errMsg, " message: ").concat(errData.message) : errMsg;
            errMsg = errData.requestId ? "".concat(errMsg, " request-Id: ").concat(errData.requestId) : errMsg;
            _context8.next = 16;
            break;

          case 14:
            _context8.prev = 14;
            _context8.t0 = _context8["catch"](6);

          case 16:
            throw new Error(errMsg);

          case 17:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[6, 14]]);
  }));
  return _handleJSONResponse.apply(this, arguments);
}

var allowedHeadersCache = new Map();

var _companionHeaders = /*#__PURE__*/_classPrivateFieldLooseKey("companionHeaders");

var _getUrl = /*#__PURE__*/_classPrivateFieldLooseKey("getUrl");

var _request = /*#__PURE__*/_classPrivateFieldLooseKey("request");

_Symbol$for = Symbol.for('uppy test: getCompanionHeaders');

var RequestClient = /*#__PURE__*/function (_Symbol$for2) {
  function RequestClient(uppy, opts) {
    _classCallCheck(this, RequestClient);

    Object.defineProperty(this, _request, {
      value: _request2
    });
    Object.defineProperty(this, _getUrl, {
      value: _getUrl2
    });
    Object.defineProperty(this, _companionHeaders, {
      writable: true,
      value: void 0
    });
    this.uppy = uppy;
    this.opts = opts;
    this.onReceiveResponse = this.onReceiveResponse.bind(this);
    _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders] = opts == null ? void 0 : opts.companionHeaders;
  }

  _createClass(RequestClient, [{
    key: "setCompanionHeaders",
    value: function setCompanionHeaders(headers) {
      _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders] = headers;
    }
  }, {
    key: _Symbol$for2,
    value: function value() {
      return _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders];
    }
  }, {
    key: "hostname",
    get: function get() {
      var _this$uppy$getState = this.uppy.getState(),
          companion = _this$uppy$getState.companion;

      var host = this.opts.companionUrl;
      return stripSlash(companion && companion[host] ? companion[host] : host);
    }
  }, {
    key: "headers",
    value: function () {
      var _headers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var defaultHeaders;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                defaultHeaders = {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  'Uppy-Versions': "@uppy/companion-client=".concat(RequestClient.VERSION)
                };
                return _context.abrupt("return", _objectSpread(_objectSpread({}, defaultHeaders), _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders]));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function headers() {
        return _headers.apply(this, arguments);
      }

      return headers;
    }()
  }, {
    key: "onReceiveResponse",
    value: function onReceiveResponse(_ref) {
      var headers = _ref.headers;
      var state = this.uppy.getState();
      var companion = state.companion || {};
      var host = this.opts.companionUrl; // Store the self-identified domain name for the Companion instance we just hit.

      if (headers.has('i-am') && headers.get('i-am') !== companion[host]) {
        this.uppy.setState({
          companion: _objectSpread(_objectSpread({}, companion), {}, _defineProperty({}, host, headers.get('i-am')))
        });
      }
    }
    /*
      Preflight was added to avoid breaking change between older Companion-client versions and
      newer Companion versions and vice-versa. Usually the break will manifest via CORS errors because a
      version of companion-client could be sending certain headers to a version of Companion server that
      does not support those headers. In which case, the default preflight would lead to CORS.
      So to avoid those errors, we do preflight ourselves, to see what headers the Companion server
      we are communicating with allows. And based on that, companion-client knows what headers to
      send and what headers to not send.
       The preflight only happens once throughout the life-cycle of a certain
      Companion-client <-> Companion-server pair (allowedHeadersCache).
      Subsequent requests use the cached result of the preflight.
      However if there is an error retrieving the allowed headers, we will try again next time
    */

  }, {
    key: "preflight",
    value: function () {
      var _preflight = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(path) {
        var _this = this;

        var allowedHeadersCached, fallbackAllowedHeaders, promise;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                allowedHeadersCached = allowedHeadersCache.get(this.hostname);

                if (!(allowedHeadersCached != null)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", allowedHeadersCached);

              case 3:
                fallbackAllowedHeaders = ['accept', 'content-type', 'uppy-auth-token'];
                promise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  var response, header, allowedHeaders;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.prev = 0;
                          _context2.next = 3;
                          return fetch(_classPrivateFieldLooseBase(_this, _getUrl)[_getUrl](path), {
                            method: 'OPTIONS'
                          });

                        case 3:
                          response = _context2.sent;
                          header = response.headers.get('access-control-allow-headers');

                          if (!(header == null || header === '*')) {
                            _context2.next = 8;
                            break;
                          }

                          allowedHeadersCache.set(_this.hostname, fallbackAllowedHeaders);
                          return _context2.abrupt("return", fallbackAllowedHeaders);

                        case 8:
                          _this.uppy.log("[CompanionClient] adding allowed preflight headers to companion cache: ".concat(_this.hostname, " ").concat(header));

                          allowedHeaders = header.split(',').map(function (headerName) {
                            return headerName.trim().toLowerCase();
                          });
                          allowedHeadersCache.set(_this.hostname, allowedHeaders);
                          return _context2.abrupt("return", allowedHeaders);

                        case 14:
                          _context2.prev = 14;
                          _context2.t0 = _context2["catch"](0);

                          _this.uppy.log("[CompanionClient] unable to make preflight request ".concat(_context2.t0), 'warning'); // If the user gets a network error or similar, we should try preflight
                          // again next time, or else we might get incorrect behaviour.


                          allowedHeadersCache.delete(_this.hostname); // re-fetch next time

                          return _context2.abrupt("return", fallbackAllowedHeaders);

                        case 19:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[0, 14]]);
                }))();
                allowedHeadersCache.set(this.hostname, promise);
                return _context3.abrupt("return", promise);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function preflight(_x2) {
        return _preflight.apply(this, arguments);
      }

      return preflight;
    }()
  }, {
    key: "preflightAndHeaders",
    value: function () {
      var _preflightAndHeaders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(path) {
        var _this2 = this;

        var _yield$Promise$all, _yield$Promise$all2, allowedHeaders, headers;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Promise.all([this.preflight(path), this.headers()]);

              case 2:
                _yield$Promise$all = _context4.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                allowedHeaders = _yield$Promise$all2[0];
                headers = _yield$Promise$all2[1];
                return _context4.abrupt("return", Object.fromEntries(Object.entries(headers).filter(function (_ref2) {
                  var _ref5 = _slicedToArray(_ref2, 1),
                      header = _ref5[0];

                  if (!allowedHeaders.includes(header.toLowerCase())) {
                    _this2.uppy.log("[CompanionClient] excluding disallowed header ".concat(header));

                    return false;
                  }

                  return true;
                })));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function preflightAndHeaders(_x3) {
        return _preflightAndHeaders.apply(this, arguments);
      }

      return preflightAndHeaders;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(path, options) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (options === void 0) {
                  options = undefined;
                } // TODO: remove boolean support for options that was added for backward compatibility.
                // eslint-disable-next-line no-param-reassign


                if (typeof options === 'boolean') options = {
                  skipPostResponse: options
                };
                return _context5.abrupt("return", _classPrivateFieldLooseBase(this, _request)[_request](_objectSpread(_objectSpread({}, options), {}, {
                  path: path
                })));

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function get(_x4, _x5) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(path, data, options) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (options === void 0) {
                  options = undefined;
                } // TODO: remove boolean support for options that was added for backward compatibility.
                // eslint-disable-next-line no-param-reassign


                if (typeof options === 'boolean') options = {
                  skipPostResponse: options
                };
                return _context6.abrupt("return", _classPrivateFieldLooseBase(this, _request)[_request](_objectSpread(_objectSpread({}, options), {}, {
                  path: path,
                  method: 'POST',
                  data: data
                })));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function post(_x6, _x7, _x8) {
        return _post.apply(this, arguments);
      }

      return post;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(path, data, options) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (data === void 0) {
                  data = undefined;
                } // TODO: remove boolean support for options that was added for backward compatibility.
                // eslint-disable-next-line no-param-reassign


                if (typeof options === 'boolean') options = {
                  skipPostResponse: options
                };
                return _context7.abrupt("return", _classPrivateFieldLooseBase(this, _request)[_request](_objectSpread(_objectSpread({}, options), {}, {
                  path: path,
                  method: 'DELETE',
                  data: data
                })));

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _delete(_x9, _x10, _x11) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return RequestClient;
}(_Symbol$for);

export { RequestClient as default };

function _getUrl2(url) {
  if (/^(https?:|)\/\//.test(url)) {
    return url;
  }

  return "".concat(this.hostname, "/").concat(url);
}

function _request2(_x12) {
  return _request3.apply(this, arguments);
}

function _request3() {
  _request3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref3) {
    var path, _ref3$method, method, data, skipPostResponse, signal, headers, response;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            path = _ref3.path, _ref3$method = _ref3.method, method = _ref3$method === void 0 ? 'GET' : _ref3$method, data = _ref3.data, skipPostResponse = _ref3.skipPostResponse, signal = _ref3.signal;
            _context9.prev = 1;
            _context9.next = 4;
            return this.preflightAndHeaders(path);

          case 4:
            headers = _context9.sent;
            _context9.next = 7;
            return fetchWithNetworkError(_classPrivateFieldLooseBase(this, _getUrl)[_getUrl](path), {
              method: method,
              signal: signal,
              headers: headers,
              credentials: this.opts.companionCookiesRule || 'same-origin',
              body: data ? JSON.stringify(data) : null
            });

          case 7:
            response = _context9.sent;
            if (!skipPostResponse) this.onReceiveResponse(response);
            return _context9.abrupt("return", handleJSONResponse(response));

          case 12:
            _context9.prev = 12;
            _context9.t0 = _context9["catch"](1);

            if (!(_context9.t0 != null && _context9.t0.isAuthError)) {
              _context9.next = 16;
              break;
            }

            throw _context9.t0;

          case 16:
            throw new ErrorWithCause("Could not ".concat(method, " ").concat(_classPrivateFieldLooseBase(this, _getUrl)[_getUrl](path)), {
              cause: _context9.t0
            });

          case 17:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, this, [[1, 12]]);
  }));
  return _request3.apply(this, arguments);
}

RequestClient.VERSION = packageJson.version;